import React, { Component } from 'react';
import { bool, string } from 'prop-types';
import classnames from 'classnames';

import Icon from 'foundations/Icons/Icon';

import styles from './PasswordStrengthMeter.css';

export default class PasswordStrengthMeter extends Component {
  static propTypes = {
    error: bool,
    description: string,
    className: string,
    finishedTyping: bool
  };

  static defaultProps = {
    className: ''
  };

  render() {
    const { className, description, finishedTyping, error } = this.props;
    const hasStrongPassword = className === 'strong' && finishedTyping && !error;
    const containerClasses = classnames(styles.container, {
      [styles[className]]: className.length,
      [styles.hasStrongPassword]: hasStrongPassword
    });
    
    return (
      <div className={containerClasses}>
        <span className={styles.meter}></span>

        {hasStrongPassword && <Icon icon={'checkmark'} type={'20'} />}

        <p className={`small ${styles.description}`}>
          {finishedTyping && !error ? 'Success.' : description}
        </p>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/uis/common/Error/PasswordStrengthMeter.js